import { CrudField } from "../CrudField";

export class HtmlField extends CrudField {
  public static fieldName = "HtmlField";
  public static viewComponentName: string = "view-html-field";
  public static formComponentName: string = "view-html-field";
}
